const subscriptionEN = {
    "view": {
        "table": {
            "title": "Your Subscription",
            "column": {
                "subscriptionTier": "Subscription Tier",
                "startDate": "Start Date",
                "currentPeriodStart": "Current Period Start",
                "currentPeriodEnd": "Current Period End",
                "autoRenewal": "Auto Renewal",
                "status": "Status",
                "action": "Action",
            },
            "label": {
                "status_active": "Active",
                "status_incomplete": "Incomplete",
                "status_incomplete_expired": "Incomplete Expired",
                "status_unpaid": "Unpaid",
                "status_past_due": "Past Due",
                "status_cancelled": "Cancelled",
                "status_expired": "Expired",
            },
            "actionDropdown": {
                "label": {
                    "action": "Action",
                },
                "button": {
                    "enableAutoRenewal": "Enable Auto Renewal",
                    "upgradeSubscription": "Upgrade Subscription",
                    "cancelSubscription": "Cancel Subscription",
                    "resumeSubscription": "Resume Subscription",
                    "retryPayment": "Retry Payment",
                },
                "message": {
                    "successSubscripionResumed": "Your subscription has been resumed, your account will be updated shortly!",
                    "successSubscripionCancelled": "Your subscription has been set to be cancelled at period end!",
                    "successSubscripionAutoRenewalEnabled": "Your subscription has been set to be renewed automatically at period end!",
                    "activeSubscription": "You already have an active subscription",
                    "incompleteSubscription": "You have a subscription which is Incomplete.",
                }
            },
            "modal": {
                "button": {
                    "cancel": "Cancel",
                    "enableAutoRenewal": "Enable Auto Renewal",
                    "cancelSubscription": "Cancel Subscription",
                }
            }
        },
        "modal": {
            "enableAutoRenewal": {
                "header": "Enable Auto Renewal",
                "body": "Are you sure that you want to enable auto-renewal for your subscription?",
            },
            "cancel": {
                "header": "Cancel Subscription",
                "body": "Are you sure that you want to cancel your subscription?",
            },
            "resume": {
                "header": "Resume Subscription",
                "body": {
                    "description": "Are you sure that you want to resume the subscription?",
                    "note": "<strong>Note:</strong> Latest subscription pricing will apply!",
                },
                "button": {
                    "cancel": "Cancel",
                    "resume": "Resume",
                },
                "message": {
                    "error": "Something went wrong! Please refresh page and try again!",
                }
            },
            "retryPayment": {
                "header": "Retry Subscription Payment",
                "body": {
                    "description": "Are you sure that you want to retry the payment for subscription?",
                    "note": "<strong>Note:</strong> Latest subscription pricing will apply!",
                },
                "button": {
                    "cancel": "Cancel",
                    "retry": "Retry",
                },
                "message": {
                    "error": "Something went wrong! Please refresh page and try again!",
                }
            }
        },
        "message": {
            "errorPaymentFailed": "Subscription payment failed please try again later!",
            "errorCardExpired": "Your card has expired. Please add a valid default <1>payment method</1> and retry payment again.",
            "errorNoPaymentMethod": "You do not have any <1>payment method</1> added to your profile. Please add a valid default <3>payment method</3> and retry payment again.",
            "moduleNoAccess": "You don't have access to this module, please contact the support team for further information.",
        }
    },
    "subscriptionTiers": {
        "form": {
            "title": "Choose Your Plan",
            "button": {
                "startNow": "Start Now",
            }
        },
        "message": {
            "error": "Something went wrong! Please refresh page and try again!",
        }
    },
    "upgrade": {
        "form": {
            "title": "Upgrade Your Subscription",
            "button": {
                "upgrade": "Upgrade",
                "currentPlan": "Current Plan",
            }
        },
        "modal": {
            "upgradeSubscription": {
                "header": "Upgrade Subscription",
                "body": {
                    "description": "Are you sure that you want to upgrade your subscription plan to <strong>{{newTierName}}</strong>.",
                    "note": "<strong>Note: The billing period for subscription will remain unchanged and you will only be invoiced for the amount excluding what you have already paid for existing plan.</strong>",
                },
                "button": {
                    "cancel": "Cancel",
                    "confirm": "Confirm",
                }
            }
        },
        "message": {
            "error": "Something went wrong! Please refresh page and try again!",
            "moduleNoAccess": "You don't have access to this module, please contact the support team for further information.",
        }
    },
    "confirmModal":{
        "header": "Confirm Your Information",
        "body": {
            "form": {
                "label": {
                    "firstName": "First Name",
                    "lastName": "Last Name",
                    "country": "Country Of Residence",
                    "refundPolicyAgreement": "By proceeding, I acknowledge and accept that this payment is final and non-refundable. <1>Refund Policy</1>",
                },
                "help_text": {
                    "firstName": "Please confirm that this is your Legal First Name.",
                    "lastName": "Please confirm that this is your Legal Last Name.",
                    "country": "Please specify your current country of residence.",
                },
                "message": {
                    "error": "Error occured while creating subscription!",
                    "note": "Note: The accuracy of the information you provide here is essential for the subsequent steps. Ensure that all information is provided accurately and truthfully.",
                }
            }
        },
        "button": {
            "cancel": "Cancel",
            "confirm": "Confirm",
        }
    },
    "upgradeFailure": {
        "view": {
            "title": "Subscription Upgrade Failed :(",
            "description": "There was an issue in upgrading your subscription. Please try again later!",
            "button": {
                "returnToDashboard": "Return to Dashboard",
            }
        }
    },
    "upgradeSuccess": {
        "view": {
            "title": "Subscription Upgraded :)",
            "description": "You have successfully upgraded your subscription, your account will be updated shortly!",
            "button": {
                "returnToDashboard": "Return to Dashboard",
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transaction Cancelled :(",
            "description": "The transaction was cancelled... Please try again later!",
            "button": {
                "returnToDashboard": "Return to Dashboard",
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transaction Successful :)",
            "description": "You have successfully confirmed your subscription, your account will be upgraded shortly!",
            "button": {
                "returnToDashboard": "Return to Dashboard",
            }
        }
    }
};

export default subscriptionEN;